<div>
    <button type="button" class="close" aria-label="Close" (click)="handleClose()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<app-path-tagging-label [processId]=processId [graphMap]=graphMap (handleSubmit)="handleClose()"></app-path-tagging-label>